import { type StyleProp, View, type ViewStyle, Text, StyleSheet } from 'react-native'
import type { PropsWithChildren } from 'react'
import { mesaColorNames, fontFamilies } from '@/src/common/theme'

export function PaymentCardInformation({
  children,
  title,
  containerStyle,
}: PropsWithChildren<{
  containerStyle?: StyleProp<ViewStyle> | undefined
  title?: string
}>) {
  return (
    <View style={[styles.balanceContainer, containerStyle]}>
      <View style={{ rowGap: 5, marginBottom: 10 }}>
        {title && <Text style={styles.currentBalanceTitle}>{title}</Text>}
        {children}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  balanceContainer: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    borderRadius: 8,
    padding: 16,
    paddingBottom: 0,
    marginBottom: 24,
  },
  currentBalanceTitle: {
    fontSize: 14,
    fontFamily: fontFamilies['PlusJakartaSans-Regular'],
    fontWeight: 400,
  },
  currentBalanceValue: {
    fontSize: 32,
    fontFamily: fontFamilies['PlusJakartaSans-Bold'],
    fontWeight: 700,
  },
  balanceInformation: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 5,
  },
  infoTitle: { fontSize: 14, fontFamily: fontFamilies['PlusJakartaSans-Regular'], fontWeight: 400 },
  infoValues: {
    fontSize: 14,
    fontFamily: fontFamilies['PlusJakartaSans-Bold'],
    fontWeight: 700,
    color: mesaColorNames['global/grey/80 #2F3133'],
  },
})
